import { ThemeConfig } from '@chakra-ui/react';

export const config: ThemeConfig = {
  cssVarPrefix: 'fp',
  initialColorMode: 'dark',
  useSystemColorMode: false,
};
